import React from 'react';

import './TradingHome.scss';
import TradingPage from 'src/containers/Page/TradingPage';

export default function TradingHome() {
  return (
    <TradingPage />
  );
}
